import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Image,
  Box,
  IconButton,
  useDisclosure,
  Flex,
  Spinner,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import { ExternalLinkIcon, DownloadIcon } from '@chakra-ui/icons'

export const ImageViewer = ({ imageUrl, alt = 'Imagem do chamado' }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  // Função para fazer download da imagem
  const handleDownload = () => {
    const link = document.createElement('a')
    link.href = imageUrl
    link.download = `chamado-imagem-${Date.now()}.jpg`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // Handler para quando a imagem carrega
  const handleImageLoad = () => {
    setIsLoading(false)
  }

  // Handler para quando há erro no carregamento da imagem
  const handleImageError = () => {
    setIsLoading(false)
    setError(true)
  }

  if (!imageUrl) return null

  return (
    <>
      <Box
        as="div"
        onClick={onOpen}
        position="relative"
        cursor="zoom-in"
        display="inline-block"
        borderRadius="md"
        overflow="hidden"
        transition="all 0.2s"
        _hover={{ transform: 'scale(1.05)', boxShadow: 'md' }}
      >
        <Image
          src={imageUrl}
          alt={alt}
          maxH="120px"
          objectFit="cover"
          borderRadius="md"
          fallback={
            <Box p={2} bg="gray.100" borderRadius="md">
              <Spinner />
            </Box>
          }
        />
        <Box position="absolute" bottom="0" right="0" bg="blackAlpha.600" color="white" p="1" borderTopLeftRadius="md" fontSize="xs">
          <ExternalLinkIcon />
        </Box>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(8px)" bg="blackAlpha.800" />
        <ModalContent bg="transparent" boxShadow="none" maxW="90vw">
          <ModalHeader bg="blackAlpha.700" color="white" borderTopRadius="md">
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="md">{alt}</Text>
              <Tooltip label="Fazer download da imagem">
                <IconButton
                  aria-label="Download image"
                  icon={<DownloadIcon />}
                  size="sm"
                  variant="ghost"
                  colorScheme="whiteAlpha"
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDownload()
                  }}
                />
              </Tooltip>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody p={0} bg="transparent" borderBottomRadius="md">
            <Flex justifyContent="center" alignItems="center" minH="300px" position="relative">
              {isLoading && <Spinner position="absolute" size="xl" thickness="4px" color="white" />}

              {error ? (
                <Box p={8} textAlign="center" color="white">
                  <Text>Não foi possível carregar a imagem</Text>
                </Box>
              ) : (
                <Image
                  src={imageUrl}
                  alt={alt}
                  maxH="80vh"
                  maxW="100%"
                  objectFit="contain"
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                  style={{ display: isLoading ? 'none' : 'block' }}
                />
              )}
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
